import React from 'react';
import {
  Box,
  Button,
  Flex,
  SimpleGrid,
  Text,
  Input,
  InputGroup,
  InputLeftElement,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Tag,
  Spinner,
} from '@chakra-ui/react';
import { IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSearch } from '@fortawesome/free-solid-svg-icons';
import apiClient from '../clients/apiClient.js';
import { useParams, useNavigate } from 'react-router-dom';
// import {
//   SearchIcon,
//   ChevronDownIcon,
//   MoreVerticalIcon,
// } from '@chakra-ui/icons';

const CollaborationForms = () => {
  const [loading, setLoading] = React.useState(false);
  const [forms, setForms] = React.useState(null);
  const [searchQuery, setSearchQuery] = React.useState(''); // State for search query

  const navigate = useNavigate();

  React.useEffect(() => {
    setLoading(true);

    apiClient
      .get('/forms/get-forms')
      .then((response) => {
        setForms(response.data.forms); // Access the response data
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching forms:', error);
        setLoading(false); // Handle errors and stop loading
      });
  }, []);

  if (loading || !forms)
    return (
      <Flex width={'100%'} height="72vh" justifyContent={'center'} alignItems={"center"} py={20}>
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="lg"
        />
      </Flex>
    );

  const filteredForms = forms.filter((form) =>
    form.form_id?.toLowerCase().includes(searchQuery.toLowerCase())
  ).sort((a,b) => b.created_at.localeCompare(a.created_at));

  return (
    <Box p={6} height={'100vh'}>
      {/* Header */}
      <Text fontSize="2xl" fontWeight="bold" mb={4}>
        Collaboration Forms
      </Text>

      {/* Summary Cards */}
      <SimpleGrid columns={[1, 2, 4]} spacing={4} mb={6}>
        <Box
          p={4}
          border="1px solid blue.500"
          shadow="xs"
          borderRadius="md"
          cursor={'pointer'}
          bg="white"
        >
          <Text color="blue.500">All forms</Text>
          <Text fontSize="2xl" fontWeight="bold" color="blue.500">
            {forms.length}
          </Text>
        </Box>
        <Box p={4} bg="white" shadow="xs" borderRadius="md" cursor={'pointer'}>
          <Text color="gray.500">Deadline approaching</Text>
          <Text fontSize="2xl" fontWeight="bold" color="gray.500">
            0
          </Text>
        </Box>
      </SimpleGrid>

      {/* Filters */}
      <Flex mb={6} align="center" gap={4}>
        <InputGroup maxW="300px">
          <InputLeftElement pointerEvents="none">
            {/* <IconButton icon={SearchIcon} style={{ color: 'grey' }} /> */}
            <IconButton style={{ color: 'grey' }} ><SearchIcon/></IconButton>
          </InputLeftElement>
          <Input
            placeholder="Search by form id"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)} // Update search query
          />
        </InputGroup>
      </Flex>

      {/* Table */}
      <TableContainer
        bg="white"
        shadow="md"
        borderRadius="md"
        height="calc(100vh - 400px)"
        overflowY="auto"
      >
        <Table variant="simple">
          <Thead position="sticky" top={0} zIndex={1} bg="white">
            <Tr>
              <Th>Forms</Th>
              <Th>Status</Th>
              {/* <Th>Next action</Th> */}
              <Th>CreatedAt</Th>
              {/* <Th>Creator</Th> */}
              {/* <Th>Deadline</Th> */}
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredForms.map((form) => {
              const {
                created_at,
                status,
                task_id,
                form_id,
              } = form;
              return (
                <Tr key={form.created_at}>
                  <Td>
                    <Button 
                        padding={0} 
                        backgroundColor={"transparent"} 
                        _hover={{backgroundColor: "transparent"}} 
                        onClick={() => navigate('/f/'+form_id)} isTruncated
                        margin={0}
                        maxH={"26px"}
                    >
                        <Text>Form Id: {form_id}</Text>
                    </Button>
                    <Text margin={0}>Task Id: {task_id || '-'}</Text>
                    {/* <Text fontSize="sm" color="gray.500">
                      ID:
                    </Text> */}
                  </Td>
                  <Td>
                    <Tag size="md" colorScheme="red">
                      {status}
                    </Tag>
                  </Td>
                  {/* <Td>Waiting on stakeholders</Td> */}
                  <Td>{created_at}</Td>
                  {/* <Td>{employee_first_name + ' ' + employee_last_name}</Td> */}
                  {/* <Td>27 Apr 2024</Td> */}
                  {/* <Td>
                    <IconButton
                      aria-label="Options"
                      //   icon={<MoreVerticalIcon />}
                      variant="ghost"
                      size="sm"
                    />
                  </Td> */}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CollaborationForms;
